import React from "react";

function WhatsAppButton() {

  const phone = "919876543210"; 
  // 👆 unga actual number replace pannunga
  // Format: countrycode + number (91xxxxxxxxxx)

  const message = "Hello, I am interested in your properties.";

  return (
    <a
      href={`https://wa.me/${phone}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        backgroundColor: "#25D366",
        color: "white",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "30px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        zIndex: 999
      }}
    >
      💬
    </a>
  );
}

export default WhatsAppButton;
